module.exports = __webpack_public_path__ + "img/iconfinder_movie.a429bd25.svg";